/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NbMenuService } from "@nebular/theme";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { SeoService } from "./@core/utils/seo.service";
import { MENU_ITEMS } from "./pages/pages-menu";
import { ApiService } from "./Restfull/api.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  branches = []
  constructor(
    private _router: Router,
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private menuService: NbMenuService,
    private apiSerivce: ApiService
  ) {
    // this.loadBranches();
    this.menuService.onItemClick().subscribe((event) => {
      this.onContecxtItemSelection(event.item.title);
    });

    // if (localStorage.getItem("") === null) {
    //   localStorage.setItem(
    //     "Menue",
    //     JSON.stringify(MENU_ITEMS, this.getCircularReplacer())
    //   );
    // }
  }

  onContecxtItemSelection(title) {
    if (title === "Log out") {
      localStorage.removeItem("Roles");
      localStorage.removeItem("User");
      localStorage.removeItem("Token");
      localStorage.removeItem("Branches");
      localStorage.removeItem("RefreshToken");
      localStorage.removeItem("Menue");
      this._router.navigate(["./auth/login"]);
    } else if (title === "Profile") this._router.navigate(["pages/profile"]);
  }
  // getCircularReplacer() {
  //   const seen = new WeakSet();
  //   return (key, value) => {
  //     if (typeof value === "object" && value !== null) {
  //       if (seen.has(value)) {
  //         return;
  //       }
  //       seen.add(value);
  //     }
  //     return value;
  //   };
  // }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
}
